// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xScreen } from "@eisinc/XDL/Utilities";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

sortSelectStyles.select = {
    sizeVariant: "small",
    labelProps: {
        ...fontConfig.singleLineSmall,
        weight: fontConfig.weight.regular,
        css: css`
            width: unset;
            padding: 0;
            letter-spacing: 0;
        `,
    },
    cssOverrides: {
        formField: css`
            align-items: center;
            gap: 8px;
            max-width: 317px;

            ${xScreen("lt", "sm")} {
                max-width: 155px;
            }
        `,
        formInputWrapper: css`
            flex: 1;
        `,
    },
};
